import React, { FC } from 'react';
import { generatePath, useHistory } from 'react-router';
import { ROUTES } from '../../../constants/routes';
import { Cell, HeaderCell, Left, NoMatching, Row, RowsWrapper, Underlined, Wrapper } from './TableStyles';

type Props = {
  reviewsRows: any[];
};
const ReviewsTable: FC<Props> = ({ reviewsRows }) => {
  const history = useHistory();
  const onClick = row => {
    const path = generatePath(ROUTES.PERMIT, {
      projectId: row.projectId,
      permitId: row.permit,
    });
    history.push(path);
  };

  return (
    <Wrapper>
      <Row>
        <HeaderCell>
          <Left>Project - Permit</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Activity Title</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Follow up</Left>
        </HeaderCell>
      </Row>
      <RowsWrapper>
        {reviewsRows.length === 0 && <NoMatching>No matching records found</NoMatching>}
        {reviewsRows.length > 0 &&
          reviewsRows.map((review, index) => {
            return (
              <Row key={index}>
                <Cell>
                  <Left>
                    <Underlined onClick={e => onClick(review)}>{`${review.projectName} - ${review.permitName}`}</Underlined>
                  </Left>
                </Cell>
                <Cell>
                  <Left>{review.activityTitleName}</Left>
                </Cell>
                <Cell>
                  <Left>{review.followUp}</Left>
                </Cell>
              </Row>
            );
          })}
      </RowsWrapper>
    </Wrapper>
  );
};

export default ReviewsTable;
